import React from 'react';
import Form from 'components/form';
import Switch from 'components/switch';
import NodeTextEditor from 'routes/surface/components/node-modal-form/components/node-text-editor';
import If from 'components/if-statement';
import { Row, WithMargin } from 'components/layout';
import useCanCreateOrEditSurfaceNode from 'routes/surface/components/node-modal-form/hooks/use-can-create-or-edit-surface-node';
import useCreateValidationSchema from 'hooks/use-create-validation-schema';
import { useSurfaceNodeTextSnippetsOperations } from 'routes/surface/hooks/use-surface-node-text-snippets';
import { useTranslation } from 'i18n';
import {
  EditorWrapper,
  NameEditor,
  SimpleBar,
  Header,
  DisabledName,
} from 'routes/surface/components/node-modal-form/style';
import { isMobile } from 'react-device-detect';
import { object, string } from 'yup';
import { NodeModalInput } from 'types';
import { SurfaceTextNode } from 'graphql/types';
import aiQuery from 'graphql/ai/queries/ai-question';

export interface TextNodeFormProps {
  onSubmit: any;
  closeForm: Function;
  initialValues: NodeModalInput<SurfaceTextNode>;
}

const defaultProps = {};

function createValidationSchema(t) {
  return object().shape({
    name: string().required(t('name is required')),
  });
}

function TextNodeForm({ initialValues, ...props }: TextNodeFormProps) {
  const { t } = useTranslation();

  const [
    allGlobalLinkIndicatorsVisible,
    setAllGlobalLinkIndicatorsVisible,
  ] = React.useState(false);

  const editorWrapper = React.useRef<HTMLElement>();

  const validationSchema = useCreateValidationSchema(createValidationSchema);

  const {
    canCreateOrEdit,
    isUpdate,
    cannotEdit,
  } = useCanCreateOrEditSurfaceNode(initialValues);

  const submitLabel = isUpdate
    ? t('Update text field')
    : t('Insert text field');

  const {
    removeDeletedSnippetFromGlobalLinkZone,
  } = useSurfaceNodeTextSnippetsOperations();

  function isNameInputAutoFocused() {
    if (isUpdate) {
      return isMobile ? false : true;
    }

    return true;
  }

  function toggleGlobalLinkIndicatorVisibility() {
    setAllGlobalLinkIndicatorsVisible(!allGlobalLinkIndicatorsVisible);
  }

  function onSubmit(values, actions, { closeTheForm = true } = {}) {
    return props.onSubmit(values, actions).then((response) => {
      actions.setSubmitting(false);

      if (response.isSuccess) {
        removeDeletedSnippetFromGlobalLinkZone(values.snippets);

        closeTheForm && props.closeForm();
      }

      return response;
    });
  }

  const queryAi = async () => {
    console.log('addasd', initialValues.id);
    const r = await aiQuery({
      input: { node: initialValues.id, type: 'category' },
    });
    console.log(' AAA ', r);
    alert(r.data.templateId);
  };

  return (
    <Form
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize={isUpdate}
      onSubmit={onSubmit}>
      {(form) => (
        <>
          <Header>
            <Form.Button
              label={t('Close')}
              onClick={props.closeForm}
              secondary
            />
            <Row alignCenter>
              {isUpdate && (
                <WithMargin right="16px">
                  <Switch
                    label={t('Show all links')}
                    onChange={toggleGlobalLinkIndicatorVisibility}
                    checked={allGlobalLinkIndicatorsVisible}
                  />
                </WithMargin>
              )}
              <WithMargin right="16px">
                <Form.Button
                  label={t('Categorize')}
                  onClick={queryAi}
                  secondary
                />
              </WithMargin>
              {canCreateOrEdit && (
                <Form.SubmitButton
                  label={submitLabel}
                  onClick={form.handleSubmit}
                />
              )}
            </Row>
          </Header>
          <EditorWrapper ref={editorWrapper}>
            <SimpleBar>
              <If condition={cannotEdit}>
                <If.Then>
                  <DisabledName>{form.values.name}</DisabledName>
                </If.Then>
                <If.Else>
                  <NameEditor
                    name="name"
                    placeholder={t('Name of document')}
                    autoFocus={isNameInputAutoFocused()}
                  />
                </If.Else>
              </If>
              <NodeTextEditor
                name="slateData"
                snippets={initialValues.snippets}
                closeForm={props.closeForm}
                onSubmit={onSubmit}
                allGlobalLinkIndicatorsVisible={allGlobalLinkIndicatorsVisible}
                readOnly={cannotEdit}
              />
            </SimpleBar>
            <SimpleBar></SimpleBar>
          </EditorWrapper>
        </>
      )}
    </Form>
  );
}

TextNodeForm.defaultProps = defaultProps;

export default TextNodeForm;
